export default "__VITE_ASSET__CMY4pygi__"